import { useEffect, useState } from 'react';
import useObservable from '../../hooks/useObservable';
import GtcStore from '../../xstores/gtc';
import React from 'react';
import {Table} from 'react-bootstrap';

const toTableData = (results:Array<any>) => {
  let data:Array<any> = [];

  results.forEach((res:any, idx:number) => {
    const newRes = [{
      query: res.query,
      row: idx + 1,
      rowSpan: res.platforms.length,
      platform: '',
      position: 0,
      page: 0,
      latency: { ...res.latency }
    }]
    res.platforms.forEach((pl:any, i:number) => {
      const { rank, page } = pl.result;
      if (newRes[i]) {
        newRes[i] = {
          ...newRes[i],
          platform: pl.name,
          position: rank,
          page,
        }
      } else {
        newRes[i] = {
          row: idx + 1,
          query: '',
          rowSpan: 1,
          platform: pl.name,
          position: rank,
          page,
          latency: { ...res.latency }
        }
      }
    });
    data = [...data, ...newRes];
  });
  return data;
}

const DataTable = () => {
  const results = useObservable(GtcStore.results$, []);
  const [tableData, setTableData] = useState<Array<any>>([]);

  useEffect(() => {
    const newData = toTableData(results);
    setTableData(newData);
  }, [results]);

  if (!results.length) {
    return null;
  }

  return (
    <Table striped bordered hover>
      <thead>
      <tr>
        <th>#</th>
        <th>Query</th>
        <th>Platform</th>
        <th>Position</th>
        <th>Page</th>
        <th>Latency</th>
      </tr>
      </thead>
      <tbody>
      {tableData.map((res:any, i:number) => (
        <tr key={`${res.query}-${i}-${res.platform}`}>
          {
            res.query ? (
              <>
                <td rowSpan={res.rowSpan}>
                  {res.row}
                </td>
                <td rowSpan={res.rowSpan}>
                  {res.query}
                </td>
              </>
            ) : null
          }
          <td>
            {res.platform}
          </td>
          <td>
            {res.position || 'Not found'}
          </td>
          <td>
            {!res.position && 'Queried pages: '}
            {res.page}
          </td>
          {res.query ? (
            <td rowSpan={res.rowSpan}>
              {Object.keys(res.latency).map((key) => (
                <div style={{color: res.latency[key] > 5 ? 'red' : 'inherit' }}>
                  Page {key}: {res.latency[key]}s
                </div>
              ))}
            </td>
          ) : null}
        </tr>
      ))}
      </tbody>
    </Table>
  )
}

export default DataTable;